import { PagePayload } from '@core/interface/core';
import {
  DocumentTypeResponse,
  DocumentTypeError,
  DocumentTypeItem,
  AddDocumentTypeResponse,
} from '@core/interface/document-type';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DocumentTypeActions = createActionGroup({
  source: 'DocumentType',
  events: {
    'Load Document Types': props<PagePayload>(),
    'Load Document Types Success': props<DocumentTypeResponse>(),
    'Load Document Types Failure': props<DocumentTypeError>(),
    'Add Edit Document Type': props<DocumentTypeItem>(),
    'Add Document Type Success': props<AddDocumentTypeResponse>(),
    'Update Document Type Success': props<AddDocumentTypeResponse>(),
    'Add Document Type Failure': props<DocumentTypeError>(),
    'Update Document Type Failure': props<DocumentTypeError>(),
    'Reset Document Type': emptyProps(),
  },
});
